import { Component } from '@angular/core';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { Scsssv } from 'app/modules/equipment-registration/model/trsssv.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';
import { Router } from '@angular/router';
import { convertToISO } from 'app/core/shared/helper/date.helper';

@Component({
  selector: 'app-trsssv',
  templateUrl: './trsssv.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./trsssv.component.scss']
})
export class TrsssvComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public trsssvForm: Scsssv = new Scsssv()
  public tempTrsssvForm: Scsssv = new Scsssv()
  public isReplace: boolean = false;

  constructor(
    private equipmentServices: EquipRegistrationServices,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.initializeTRSVForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return;

      if (wellEquipment?.scssv) {
        this.trsssvForm = new Scsssv(wellEquipment?.scssv);
      } else {
        this.initializeTRSVForm()
      }

      this.handdleFormValue(wellEquipment)
      this.tempTrsssvForm =  new Scsssv(this.trsssvForm)
    })

    this.equipmentServices.isReplace$.subscribe(value => {
      this.isReplace = value;
    });
  }

  private initializeTRSVForm(): void {
    this.trsssvForm.reset()
  }

  private handdleFormValue(wellEquipment: any) {
    if (!this.trsssvForm.mdSssvTypeId) {
      this.setScssvTypeId()
    }

    this.trsssvForm.wellStringId = wellEquipment.wellStringId
    this.trsssvForm.isSelfEqualize = this.trsssvForm.isSelfEqualize != null ? this.trsssvForm.isSelfEqualize.toString() : ''
    this.trsssvForm.blowingGas = this.trsssvForm.blowingGas != null ? this.trsssvForm.blowingGas.toString() : ''
    this.trsssvForm.slamTest = this.trsssvForm.slamTest != null ? this.trsssvForm.slamTest.toString() : ''
    this.trsssvForm.isLockedOpen = this.trsssvForm.isLockedOpen != null ? this.trsssvForm.isLockedOpen.toString() : ''
  }

  private setScssvTypeId() {
    this.equipmentServices.getSssvTypeId('IV').subscribe(id => {
      this.trsssvForm.mdSssvTypeId = this.tempTrsssvForm.mdSssvTypeId = id
    })
  }

  disabledSave() {
    return !this.trsssvForm.mdSssvTypeId || !this.trsssvForm.wellStringId || this.isFormChange()
  }

  private isFormChange() {
    return JSON.stringify(this.trsssvForm) === JSON.stringify(this.tempTrsssvForm);
  }

  save() {
    const operation = this.isReplace ?
      this.equipmentServices.addTrSssv(this.trsssvForm) :
      this.equipmentServices.updateSceScsssv(this.trsssvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.trsssvForm.wellStringId).subscribe();
      }
    });
  }
}
